import { Injectable } from '@angular/core';
import { ZAPICall, ZAPICallClient } from '@z-api/call';
import { firstValueFrom } from 'rxjs';
import { AlertService } from '../shared/components/alert/alert.service';
import { ChannelService } from './channel.service';

const WIDGET_HOST_ID = 'zapi-call-widget';

@Injectable({ providedIn: 'root' })
export class ZAPICallManagerService {
  private clients = new Map<string, ZAPICallClient>();
  private starting = false;

  constructor(
    private readonly channelService: ChannelService,
    private readonly alertService: AlertService,
  ) { }

  async start(): Promise<void> {
    if (this.starting) return;
    this.starting = true;
    try {
      const channels = await firstValueFrom(this.channelService.listZAPIIncomingEnabled());
      for (const channel of channels) {
        const client = ZAPICall.init({
          instanceId: channel.instanceId,
          getToken: async () => {
            const { token } = await firstValueFrom(this.channelService.getCallVoipToken(channel._id));
            return token;
          },
        });
        this.hideWidget();
        client.on('call:incoming', (call) => { this.showWidget(); client.openWidget(); });

        client.on('call:outgoing', (call) => { this.showWidget(); client.openWidget(); });

        client.on('call:terminated', (id, reason) => { setTimeout(() => this.hideWidget(), 500); });

        client.on('error', (err) => console.error('[ZAPICall] error', channel._id, err));

        this.clients.set(channel._id, client);

        (window as any).__zapiClient = client;
      }
    } catch (e) {
      console.error('[ZAPICall] start failed', e);
    } finally {
      this.starting = false;
    }
  }

  stop(): void {
    for (const client of this.clients.values()) {
      try { client.destroy(); } catch { /* noop */ }
    }
    this.clients.clear();
  }

  makeOutboundCall(channelId: string, phone: string, isVideo = false): void {
    const client = this.clients.get(channelId);
    if (!client) {
      this.alertService.error('Canal não está pronto para chamadas. Recarregue a página e tente novamente.');
      console.error('[ZAPICall] no client registered for channel', channelId);
      return;
    }
    this.showWidget();
    client.makeCall(phone, isVideo);
  }

  private hideWidget(): void {
    document.querySelectorAll<HTMLElement>(`#${WIDGET_HOST_ID}`).forEach(el => el.style.display = 'none');
  }

  private showWidget(): void {
    document.querySelectorAll<HTMLElement>(`#${WIDGET_HOST_ID}`).forEach(el => el.style.display = '');
  }
}
